import { FETCH_HF_SUCCESS, FETCH_HF_ERROR } from "../actions/hfActions";

const initialState = {
  hfData: [],
  error: null,
};

const hfReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_HF_SUCCESS:
      return {
        ...state,
        hfData: action.payload,
      };
    case FETCH_HF_ERROR:
      return {
        ...state,
        error: action.payload,
        hfData: [],
      };
    default:
      return state;
  }
};

export default hfReducer;
